import { api } from './auth.service';

const clienteParticipanteService = {

  // Lista todos os participantes cadastrados para um cliente.
  // Se passar negocioId, cada item traz a flag 'vinculado' indicando se já
  // está associado ao negócio.
  listarPorCliente: async (clienteId, negocioId = null) => {
    const qs = negocioId ? `?negocio_id=${negocioId}` : '';
    const res = await api.get(`/participantes/cliente/${clienteId}${qs}`);
    return res.data;
  },

  // Lista apenas os participantes vinculados a um negócio
  listarPorNegocio: async (negocioId) => {
    const res = await api.get(`/participantes/negocio/${negocioId}`);
    return res.data;
  },

  // Cria participante novo (opcionalmente já vincula ao negócio)
  incluir: async (clienteId, dados) => {
    const res = await api.post(`/participantes/cliente/${clienteId}`, dados);
    return res.data;
  },

  // Vincula um participante existente a um negócio
  vincular: async (negocioId, participanteId) => {
    const res = await api.post('/participantes/vincular', {
      negocio_id: negocioId,
      participante_id: participanteId,
    });
    return res.data;
  },

  // Desvincula do negócio (mantém cadastro global)
  desvincular: async (negocioId, participanteId) => {
    const res = await api.delete(`/participantes/negocio/${negocioId}/${participanteId}`);
    return res.data;
  },

  // Exclui definitivamente do cadastro do cliente (afeta outros negócios!)
  excluir: async (participanteId) => {
    const res = await api.delete(`/participantes/${participanteId}`);
    return res.data;
  },
};

export default clienteParticipanteService;
